import { Instagram, Facebook } from "lucide-react";
import { SOCIALS } from "../data/site";

const ICONS = { Instagram, Facebook };

export default function SocialLinks({ className = "", testIdPrefix = "social" }) {
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid={`${testIdPrefix}-links`}>
      {SOCIALS.map((s) => {
        const Icon = ICONS[s.icon];
        return (
          <a
            key={s.label}
            href={s.href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`${s.label} (opens in a new tab)`}
            data-testid={`${testIdPrefix}-${s.label.toLowerCase()}-link`}
            className="flex h-9 w-9 items-center justify-center border border-gold/30 text-gold transition-colors duration-300 hover:border-gold hover:bg-gold/10 hover:text-gold-light"
          >
            <Icon className="h-4 w-4" />
          </a>
        );
      })}
    </div>
  );
}
